import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const InviteAllGuardiansMutation = graphql.persisted(
  'InviteAllGuardians',
  graphql(`
    mutation InviteAllGuardians($input: InviteAllGuardiansInput!) {
      inviteAllGuardians(input: $input) {
        sentCount
        skippedCount
        results {
          person { id fullName }
          status
          reason
          sentEmail
        }
        userErrors { message path }
      }
    }
  `)
);

const InviteAllStaffMutation = graphql.persisted(
  'InviteAllStaff',
  graphql(`
    mutation InviteAllStaff($input: InviteAllStaffInput!) {
      inviteAllStaff(input: $input) {
        sentCount
        skippedCount
        results {
          person { id fullName }
          status
          reason
          sentEmail
        }
        userErrors { message path }
      }
    }
  `)
);

export { InviteAllGuardiansMutation, InviteAllStaffMutation };

export function useInviteAllGuardians() {
  return useMutation(InviteAllGuardiansMutation);
}

export function useInviteAllStaff() {
  return useMutation(InviteAllStaffMutation);
}
